

module.exports = __webpack_require__.stylable.create(
    "Divider3971670231",
    {"classes":{"root":"Divider3971670231__root"},"vars":{},"stVars":{"MainColor":"color-5","MainWidth":"1","MainDividerColor":"color-5","MainDividerWidth":"1"},"keyframes":{}},
    "",
    1,
    "Divider3971670231",
    null
);
